export const baseURL = process.env.REACT_APP_BASE_URL 

export const socketURL = process.env.REACT_APP_SOCKET_URL